/**
 * Escolhe QUAL funil a página de negócio (pipeline/negocio/:id) deve usar.
 *
 * A página recebe o funil por `?funnelId=` na URL. Mas o negócio pode ser
 * aberto por caminhos que NÃO carregam essa query (ex.: o widget "Negócios" da
 * conversa). Nesses casos NÃO se pode cair no primeiro funil da conta: o Ganho/
 * Perda/mover miram esse funil e o backend recusa com "Conversa não está neste
 * funil" (mascarado no front como "Erro ao marcar deal como ganho").
 *
 * Ordem de resolução:
 *   1. Funil explícito da URL (?funnelId=), se casar com a lista.
 *   2. Sem funnelId: o funil do mapping REAL da conversa — preferindo o card
 *      ainda aberto (é ele que se marca como ganho).
 *   3. Último recurso: primeiro funil (ou {} enquanto a lista não carregou).
 *
 * @param {Object} params
 * @param {Array}  [params.funnels] - lista de funis da conta (funnels/getFunnels)
 * @param {number|string} [params.funnelId] - funil da query da rota (pode faltar)
 * @param {Object} [params.conversation] - conversa com funnel_mappings
 * @returns {Object} o funil escolhido (ou {} se a lista ainda não carregou)
 */
export function resolveDealFunnel({
  funnels = [],
  funnelId,
  conversation,
} = {}) {
  const byQuery =
    funnelId !== undefined && funnelId !== null && funnelId !== ''
      ? funnels.find(f => String(f.id) === String(funnelId))
      : null;
  if (byQuery) return byQuery;

  const maps = conversation?.funnel_mappings || [];
  const chosen = maps.find(m => m.deal_status === 'open') || maps[0];
  const byMapping = chosen
    ? funnels.find(f => String(f.id) === String(chosen.funnel_id))
    : null;
  if (byMapping) return byMapping;

  return funnels[0] || {};
}
